import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HEATMAP_DEFAULT_RADIUS, HEATMAP_DEFAULT_MAX_RADIUS, HEATMAP_MAX_RADIUS_COEFFICIENT } from "config/heatmap";
import { AppThunk } from "../../app/store";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export interface SelectedClicksRadiusState {
  selectedClicksRadius: number;
  clickRadiusMax: number;
}

const initialState: SelectedClicksRadiusState = {
  selectedClicksRadius: HEATMAP_DEFAULT_RADIUS,
  clickRadiusMax: HEATMAP_DEFAULT_MAX_RADIUS,
};

const selectedClicksRadiusSlice = createSlice({
  name: "selectedClicksRadius",
  initialState: initialState,
  reducers: {
    resetSelectedClicksRadius: () => initialState,
    setSelectedClicksRadius: (state, action: PayloadAction<number>) => {
      state.selectedClicksRadius = action.payload;
    },
    setClicksRadiusMax: (state, action: PayloadAction<number>) => {
      state.clickRadiusMax = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const { selectedClicksRadius } = action.payload.projectSettings;
      return selectedClicksRadius ?? initialState;
    });
  },
});

export const { setSelectedClicksRadius, setClicksRadiusMax, resetSelectedClicksRadius } =
  selectedClicksRadiusSlice.actions;

export const updateRadiusSettings =
  ({ width, height }: { width: number; height: number }): AppThunk =>
  (dispatch, getState) => {
    const { clickRadiusMax, selectedClicksRadius } = getState().selectedClicksRadius;

    const newMaxRadius = Math.max(clickRadiusMax, Math.floor(Math.min(height, width) * HEATMAP_MAX_RADIUS_COEFFICIENT));
    const newRadius = Math.min(selectedClicksRadius, newMaxRadius);
    dispatch(setClicksRadiusMax(newMaxRadius));
    dispatch(setSelectedClicksRadius(newRadius));
  };

export default selectedClicksRadiusSlice.reducer;
